<template>
  <div class="lamp-term-cemar">
    <div class="row">
      <div class="col-xs-3">
        <img src="/static/img/cema-logo.png" class="img-responsive">
      </div>
      <div class="col-xs-6 text-center"><h5 class="text-center">Termo de Responsabilidade</h5></div>
      <div class="col-xs-3">
        <p style="color: #aaaaaa; text-align: right; font-size: 5pt;"> {{ `${payload.eventId}-${payload.customer._id}` }} </p>
      </div>
    </div>

    <div class="row margin-top">
      <div class="col-xs-12">
        <p>
          A COMPANHIA ENERGÉTICA DO MARANHÃO – CEMAR, empresa privada, concessionária de serviços públicos, com sede na cidade de São Luís, Estado do Maranhão, na Alameda A, Quadra SQS, nº. 100, Loteamento Quitandinha – Altos do Calhau, devidamente inscrita no CNPJ 06.272.793/0001-84, e o(a) Sr.(a). {{ payload.customer.holder }}, RG {{ payload.customer.nationalId }}, C.P.F.: {{ payload.customer.cpf }}, e N.I.S./N.I.T./N.B. {{ payload.customer.nis }} <span v-if="payload.customer.nis === ''">N/C</span> residente e domiciliado(a) na {{ payload.customer.address.street }} nº {{ payload.customer.address.number }} CDN n.º {{ payload.customer.uc }} firmam o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:
        </p>
        <h4>Cláusula Primeira &#8212; CONSIDERAÇÕES PRELIMINARES</h4>
        <ol>
          <li>
            A CEMAR está desenvolvendo o “Projeto Comunidade Eficiente - + Economia” que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades sócio-educativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;
          </li>
          <li>
            No tocante às praticas relacionadas ao uso racional de energia elétrica, enquadra-se como tal, o uso de lâmpadas econômicas;
          </li>
          <li>
            A CEMAR buscando viabilizar essa prática nas comunidades atendidas pelo “Projeto Comunidade Eficiente - + Economia”, entre outras ações, disponibilizará lâmpadas econômicas para serem substituídas nas unidades consumidoras atendidas, nas condições seguintes:
          </li>
        </ol>
        <h4>Cláusula Segunda &#8212; CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO</h4>
        <ol>
          <li>
            A CEMAR realizará a troca de até {{ payload.config.lamps.max }} lâmpadas fluorescente ou incandescentes, por lâmpadas de LED de {{ powerLampDeliveryLabel }}W devendo estas ser entregues à CEMAR no ato da substituição;
          </li>
          <li>
            O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à CEMAR  para substituição.
          </li>
          <li>
            O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a CEMAR.
          </li>
        </ol>
        <h4>Cláusula Terceira &#8212; DAS OBRIGAÇÕES DO USUÁRIO</h4>
        <ol>
          <li>
            O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “Projeto Comunidade Eficiente - + Economia” suspensos;
          </li>
          <li>
            O usuário, desde já, autoriza a inspeção pelos funcionários da CEMAR, para verificação da quantidade/estado das lâmpadas substituídas, em caso de irregularidade terá todos os benefícios oriundos do “Projeto Comunidade Eficiente - + Economia”  suspensos.
          </li>
        </ol>
        <ol style="margin-top: .5cm;">
          <li>Quantas lâmpadas ficam ligadas no horário das 17:30 às 20:30? _____________
          </li>
          <li>Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________
          </li>
        </ol>
        <p style="margin-top: .5cm;">
          Fortaleza, {{ new Date() | moment('D') }}, {{ new Date() | moment('MMMM') }} de {{ new Date() | moment('YYYY') }}
        </p>
        <p style="text-align: center; margin-top: 30px;">
          <span style="display: inline-block; border-bottom: 1px solid #000; min-width: 500px; width: 70%; "> </span>
          <br>
          <span class="uppercase"> {{ payload.customer.holder }} </span>
          <br>
          <span v-if="payload.customer.cpf"> CPF: {{ payload.customer.cpf }} </span>
          <br>
          <span v-if="payload.customer.nationalId"> RG: {{ payload.customer.nationalId }} </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SignatureCustomerTicket from 'src/pages/Documents/SignatureCustomerTicket'

export default {
  name: 'lamp-term-cemar',

  components: { SignatureCustomerTicket },

  props: {
    payload: {},

    powerLampDeliveryLabel: {
      required: true,
      type: String
    },
    ticket: {
      default: () => Object.assign({})
    }
  }
}
</script>

<style scoped>
  .fields {
    font-weight: bold;
  }

  p, li {
    font-size: 8pt;
    text-align: justify;
  }

  @page {
    size: A4;   /* auto is the current printer page size */
    margin: 1cm;  /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/Cemar/LampTermCemar.vue